import { render, staticRenderFns } from "./ExpandableContent.vue?vue&type=template&id=6ffb239b"
import script from "./ExpandableContent.vue?vue&type=script&lang=js"
export * from "./ExpandableContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports